<div class="info-field">
  <label class="info-field__label">{{label}}</label>
  <div class="info-field__value">
    <ng-content></ng-content>
  </div>
</div>